import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  dateKey,
  isBannerConfigured,
  shouldShowBanner,
  shouldShowPopup,
  getPopupLastShown,
  setPopupLastShown,
} from '../utils/promo';
import usePromo from './usePromo';

export type PromoSurface = 'banner' | 'popup' | 'both';

let sessionPopupDecision: { promoId: string; open: boolean } | null = null;

export default function usePromoPrompt(mode: PromoSurface = 'both') {
  const promo = usePromo();

  const [bannerOpen, setBannerOpen] = useState(
    mode !== 'popup' && isBannerConfigured(promo)
  );
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !promo) return;
    const nowMs = dayjs().valueOf();

    const preview = new URLSearchParams(window.location.search).has(
      'promoPreview'
    );

    if (mode !== 'popup') {
      const bannerVisible = preview
        ? promo.showBanner && !!promo.bannerHeading && !!promo.bannerCtaUrl
        : shouldShowBanner(promo, nowMs);
      setBannerOpen(bannerVisible);
    }

    if (mode !== 'banner') {
      if (preview) {
        if (promo.showPopup && promo.modalHeading && promo.popupCtaUrl)
          setPopupOpen(true);
      } else if (sessionPopupDecision?.promoId === promo.promoId) {
        setPopupOpen(sessionPopupDecision.open);
      } else {
        const show = shouldShowPopup(promo, {
          nowMs,
          lastShownKey: getPopupLastShown(promo.promoId),
        });
        if (show) setPopupLastShown(promo.promoId, dateKey(nowMs));
        sessionPopupDecision = { promoId: promo.promoId, open: show };
        setPopupOpen(show);
      }
    }
  }, []);

  const closePopup = () => {
    setPopupOpen(false);
    // Remember the dismissal so a later remount this session doesn't reopen it.
    if (promo && sessionPopupDecision?.promoId === promo.promoId) {
      sessionPopupDecision.open = false;
    }
  };

  return { promo, bannerOpen, popupOpen, closePopup };
}
